import React from 'react'
import {
  MetricCard,
  MetricCardGrid,
  metricCardFromReportsKpi,
} from '@enamelai/design-system'
import { ReportsKpiMetric } from '@dataTypes/reports.type'
import {
  toKpiValueDisplay,
  toSentenceCase,
  toSentenceCaseProse,
} from '@utils/textCase.util'

type ReportKpiGridProps = {
  items: ReportsKpiMetric[]
}

function ReportKpiGrid({ items }: ReportKpiGridProps): React.ReactElement {
  return (
    <MetricCardGrid
      columns={
        items.length > 6
          ? 7
          : (Math.max(2, items.length) as 2 | 3 | 4 | 5 | 6 | 7)
      }
      className="reports-patient-base-health__kpi-grid"
    >
      {items.map((item) => {
        const metricCard = metricCardFromReportsKpi(item)

        return (
          <MetricCard
            key={item.id}
            {...metricCard}
            label={toSentenceCase(metricCard.label ?? '')}
            value={
              typeof metricCard.value === 'string'
                ? toKpiValueDisplay(metricCard.value)
                : metricCard.value
            }
            footer={
              typeof metricCard.footer === 'string'
                ? toSentenceCaseProse(metricCard.footer)
                : metricCard.footer
            }
          />
        )
      })}
    </MetricCardGrid>
  )
}

export default ReportKpiGrid
